// extracted by mini-css-extract-plugin
export default {"demo":"demo_demo__MhNbG","container":"demo_container__IIQ9D index_container__UOiPn","demoScreen":"demo_demoScreen__Z-XvZ"};